import script from "./ToplantiNotlari.vue?vue&type=script&setup=true&lang=js"
export * from "./ToplantiNotlari.vue?vue&type=script&setup=true&lang=js"

import "./ToplantiNotlari.vue?vue&type=style&index=0&id=b8a0344e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8a0344e"]])

export default __exports__